import { ConfigActionTypes } from './type';

export const fetch_channel_config = (options: any, onSuccess: any) => ({ type: ConfigActionTypes.FETCH_CHANNEL_CONFIG, options, onSuccess });

export const fetch_banner = (options: any, onSuccess: any) => ({ type: ConfigActionTypes.FETCH_BANNER, options, onSuccess });

export const fetch_userAccountInfo = (options?: object, onSuccess?: () => void) => ({ type: ConfigActionTypes.FETCH_USERINFO, options, onSuccess });

export const fetch_addWechatResource = (options?: object, onSuccess?: () => void) => ({ type: ConfigActionTypes.FETCH_ADDWECHATRESOURCES, options, onSuccess });

export const set_showAddWechat = () => ({ type: ConfigActionTypes.FETCH_ADDWECHATRESOURCES_SUCCESS, data: { showAddWechat: true } });